import React from 'react';
import {hardRedirectToAuth} from "@/src/shared/lib/axios";

function requireAuth<TProps extends object>(
    Wrapped: React.ComponentType<TProps>,
) {

    function Guarded(props: TProps) {
        if (typeof window !== "undefined") {
            const hasToken = !!localStorage.getItem('access_token')
            if (!hasToken) {
                hardRedirectToAuth()
                return
            }
        }

        return <Wrapped {...props} />;
    }

    return Guarded
}

export default requireAuth;